/** @prettier */

/**
 * 課金
 */
//Style import
import '../../css/common/common.css';
import BillingInformationTable from './BillingInformationTable';
import {Grid, Container} from '@mui/material';
import {useTranslation} from 'react-i18next';

const BillingSetting = () => {
  const trans = useTranslation().t; //翻訳関数

  return (
    <Container fixed>
      <Grid container rowSpacing={3}>
        <Grid item xs={12}>
          <h1>{trans('BillingSetting.title')}</h1>
          <p className="billingSetting__description">
            <div>{trans('BillingSetting.text.description1')}</div>
            <div>{trans('BillingSetting.text.description2')}</div>
          </p>

          <p className="billingSetting__description__note">
            <div>{trans('BillingSetting.text.note')}</div>
            <ul>
              <li>{trans('BillingSetting.text.message1')}</li>
              <li>{trans('BillingSetting.text.message2')}</li>
            </ul>
          </p>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} className="billingSetting__tableBox">
          {/* ゲートウェイ一覧の表示 */}
          <BillingInformationTable />
        </Grid>
      </Grid>
    </Container>
  );
};
export default BillingSetting;
